export default __webpack_public_path__ + "static/media/strofe_product.43ce1efd.png";